@let items = data.items;
@if (items) {
  <section class="centered-with-padding flex flex-col pb-14 pt-7">
    @for (item of items; track index; let index = $index; let odd = $odd) {
      @let hasTipBlock = item.tipBlock && item.tipBlock.text;
      @let isOpen = openedItemIndex() === index;
      <div
        #accordionItem
        [class.desk:mb-0]="isOpen"
        [class.desk:mb-14]="isOpen && !hasTipBlock"
        [class.desk:mb-20]="!isOpen"
        [class.mb-2.5]="isOpen && hasTipBlock"
        [class.mb-8]="isOpen && !hasTipBlock"
        class="mb-14 last:mb-0 desk:pl-10">
        <div
          [class.desk:pb-1.5]="hasTipBlock && isOpen"
          [class.pb-10]="hasTipBlock && isOpen"
          class="relative z-0 rounded-2xl bg-gray-light py-4">
          <div
            [class.rotate-[-4deg]]="!odd"
            [class.rotate-[4deg]]="odd"
            class="absolute -left-3 -top-4 flex h-[71px] w-[60px] items-center justify-center rounded-2xl bg-purple font-title text-[60px] desk:-left-10 desk:-top-5 desk:h-[129px] desk:w-[109px] desk:rounded-3xl desk:text-[100px]">
            {{ index + 1 }}
          </div>
          <div
            (click)="toggleItemOpen(index)"
            class="group grid cursor-pointer grid-cols-[1fr_auto] pl-14 pr-2.5 desk:py-5 desk:pl-28">
            <div class="font-title text-[30px] leading-[33px] desk:text-[40px]">{{ item.title }}</div>
            <div class="flex items-center px-4">
              <app-svg
                [class.group-hover:rotate-[25deg]]="!isOpen"
                [class.rotate-90]="isOpen"
                [height]="22"
                [width]="11"
                class="transition-transform"
                src="assets/icons/caret-right.svg" />
            </div>
          </div>
          @if (isOpen) {
            <div [class.pb-2.5]="!hasTipBlock" class="px-4 pt-7 desk:pb-10">
              @if (data.context === "priceExplanation") {
                <div
                  class="relative grid grid-cols-1 items-center gap-y-4 supports-[text-wrap:pretty]:text-pretty desk:grid-cols-[350px_auto] desk:gap-x-5">
                  <div class="h-[423px] overflow-hidden rounded-2xl desk:h-[467px]">
                    @let image = item.medias![0];
                    @if (image | isImage) {
                      <app-image [image]="image" [isPriority]="!isImageInPreviousBlocks && index < 2" />
                    }
                  </div>
                  <div
                    [class.pb-2.5]="item.tipBlock"
                    [innerHTML]="item.text"
                    class="prose prose-p:mt-0 prose-p:leading-[19px] prose-a:underline prose-strong:font-bold prose-li:leading-[19px] desk:pr-10"
                    handleHtmlLinks></div>
                </div>
              }
              @if (data.context === "franchiseProjectSteps") {
                @let twoMedias = item.medias?.length === 2;
                <div
                  class="grid grid-cols-1 items-center gap-x-5 gap-y-2.5 desk:w-fit desk:grid-cols-[1fr_auto] desk:gap-y-5">
                  @for (media of item.medias; track $index) {
                    <div class="aspect-video overflow-hidden rounded-3xl desk:w-[353px]">
                      @if (media! | isImage) {
                        <app-image [image]="media" [isPriority]="!isImageInPreviousBlocks && index < 2" />
                      } @else if (media! | isVideo) {
                        <app-video [video]="media" />
                      } @else if ("link" in media!) {
                        <app-youtube-player [videoId]="media.link | youtubeIdExtractor" />
                      }
                    </div>
                  }
                  <div [class]="twoMedias ? 'desk:col-span-2' : ''">
                    <div [innerHTML]="item.text" class="prose"></div>
                    @if (item.cta; as cta) {
                      @let gtm = data.gtmConfigItemsCta;
                      <div class="mx-auto mt-2.5 w-fit desk:mx-0">
                        <app-button
                          (onButtonClick)="
                            emitGtmEvent({
                              event: gtm?.event,
                              group: gtm?.group,
                              description: gtm?.description,
                              context: gtm?.context,
                              button_text_value: cta.label,
                              event_type: 'click',
                            })
                          "
                          [label]="cta.label"
                          [url]="cta.url" />
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
        @let tipBlock = item.tipBlock;
        @if (isOpen && tipBlock && tipBlock.text) {
          <div class="flex justify-end desk:pr-16">
            <div class="relative -top-8 z-10 mx-3.5 flex flex-col gap-4 rounded-xl bg-purple px-6 py-4 desk:w-[412px]">
              <div
                class="font-title text-[30px] leading-[28px] tracking-[-0.6px] desk:text-[35px] desk:leading-[34px] desk:tracking-[-0.7px]">
                {{ tipBlock.title }}
              </div>
              <div [innerHTML]="tipBlock.text" class="[&_a]:underline" handleHtmlLinks></div>
              @if (tipBlock.cta; as cta) {
                <app-button [label]="cta.label" [url]="cta.url" class="mx-auto text-center" theme="WHITE" />
              }
            </div>
          </div>
        }
      </div>
    }
  </section>
}
